var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-style"},[_c('el-switch',{attrs:{"active-value":"white","inactive-value":"black","active-color":"#FEBA4A","inactive-color":"#8E8E8E"},on:{"change":_vm.changeStyle},model:{value:(_vm.style),callback:function ($$v) {_vm.style=$$v},expression:"style"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }